import axios from 'axios';

//local
// const apiUrl = 'https://house-of-theta-quiz.herokuapp.com'
// const clientUrl = 'http://192.168.43.238:3000';
// const clientUrl = 'http://localhost:3000';

//local
// const apiUrl = 'http://localhost:5000';

const apiUrl = 'https://house-project-2882.nw.r.appspot.com';

//global
// const apiUrl = 'http://139.162.247.113:3071'
// const clientUrl = 'http://139.162.247.113:3072';



// require('dotenv').config();

export function createGame(object) {
    return axios.post(`${apiUrl}/games`, object)
}
export function login(obj){
    console.log("signing be ",obj);
    return axios.post(`${apiUrl}/users/login`, obj)
}
export function register(obj){
    console.log("registering be ",obj);
    return axios.post(`${apiUrl}/users/signup`, obj)
}

export function closeNotification(context) {
    setTimeout(function () {
        context.setState({
            isShowing: false,
            game: '',
            date: '',
            time: ''
        })
    }, 1500)
}
export function changePassword(obj){
    return axios.post(`${apiUrl}/users/change`, obj)
}

export function getAllGames(type) {
    console.log("Getting all games");
    return axios.get(`${apiUrl}/games`);
}
export function getResponds() {
    console.log("Getting all Responds");
    return axios.get(`${apiUrl}/games/responds`);
}

export function markQuestion(gameId,q_num,st) {
    //marks question as imbalance
    return axios.post(`${apiUrl}/games/${gameId}/question`,{number: q_num,stat:st });
}

export function changeEntry(gameId,tw) {
    return axios.post(`${apiUrl}/games/active`,{gentry: gameId,stat:tw });
}

export function sendVideo(gameId,v_url) {
    return axios.post(`${apiUrl}/games/${gameId}/video`,{video: v_url });
}
export function fixScale(gameId,obj) {
    return axios.post(`${apiUrl}/games/${gameId}/fixed`,{scale:obj,gid:gameId});
}

export function getGame(gameId) {
    return axios.get(`${apiUrl}/games/${gameId}`);
}

export function deleteGame(gameId) {
    return axios.delete(`${apiUrl}/games/${gameId}`);
}

export function editGame(gameId, object) {
    return axios.patch(`${apiUrl}/games/${gameId}`, {update: object})
}

export function handleCatch(err,context) {
    context.setState({
        message: err,
        isShowing: true,
        status: 'ERROR!',
        alert: 'danger'
    })
}

//messages api calls
export function getMessages() {
    return axios.get(`${apiUrl}/games/msgs`);
}

export function deleteMessage(mid) {
    return axios.delete(`${apiUrl}/games/dmsg/${mid}`);
}

export function addMessage(obj) {
    return axios.post(`${apiUrl}/games/amsg`,obj);
}
export function editMessage(oid,object) {
    return axios.patch(`${apiUrl}/games/emsg/${oid}`, {update: object})
}


// WEBPACK FOOTER //
// ./src/services/GameServices.jsx